import styled from 'styled-components';

interface IDictionary {
  [index: string]: string;
}

type DividerProps = {
  marginTop?: string;
  marginBottom?: string;
  marginLeft?: string;
  marginRight?: string;
  colorVariant?: string;
};

const defaultProps = {
  marginTop: '0rem',
  marginBottom: '0rem',
  marginLeft: '0rem',
  marginRight: '0rem',
  colorVariant: 'gray15',
};

const getStyleColor = (colors: IDictionary, colorVariant?: string): string => {
  if (colorVariant) return colors[colorVariant];
  return 'var(--gray-15)';
};

const StyledDivider = styled.hr<DividerProps>`
  width: 100%;
  border: 0.0625rem solid
    ${(props): string => getStyleColor(props.theme.colors, props.colorVariant)};
  border-radius: 0.625rem;
  margin-top: ${(props): string | undefined => props.marginTop};
  margin-bottom: ${(props): string | undefined => props.marginBottom};
  margin-left: ${(props): string | undefined => props.marginLeft};
  margin-right: ${(props): string | undefined => props.marginRight};
`;

const Divider = (props: DividerProps): JSX.Element => (
  <StyledDivider {...props} />
);

Divider.defaultProps = defaultProps;

export default Divider;
